import type { ClinicalNote } from '../../clients/data/types';

/** Scored measures duplicated into chart bundle `clinicalNotes` for Medical Record. */
function isAssessmentChartNote(note: ClinicalNote): boolean {
  return note.noteType === 'Assessments' || note.type === 'Assessments' || Boolean(note.assessmentId);
}

export interface FilterZoomSidebarClinicalNotesOptions {
  /** Exclude notes linked to this appointment (current session). */
  excludeAppointmentId?: string;
}

/**
 * Zoom sidebar: past appointment-linked clinical notes for the episode
 * (not PHQ/GAD measures; not the current appointment).
 */
export function filterZoomSidebarClinicalNotes(
  notes: readonly ClinicalNote[],
  options: FilterZoomSidebarClinicalNotesOptions = {},
): ClinicalNote[] {
  const excludeId = options.excludeAppointmentId?.trim();
  return notes.filter((n) => {
    if (isAssessmentChartNote(n) || !n.appointmentId) return false;
    if (excludeId && n.appointmentId === excludeId) return false;
    return true;
  });
}
